import React from "react";
import "./styles.scss";

//IMAGES
import xxiiiBackground from "../../assets/images/xxiii_image.png";
import xxiiiLogo from "../../assets/logos/XXIII_logo.svg";
import creative from "../../assets/images/insta-07.jpg";
import tcBackground from "../../assets/images/jade-ocean_building04.jpg";
import gastro from "../../assets/images/food-08.jpg";
import gears from "../../assets/images/insta-38.jpg";
import tcLogo from "../../assets/logos/tc-miami_logo.svg";
import jadeOcean from "../../assets/images/055A1767.jpg";
import ora from "../../assets/images/ora01.jpg";
import jadeSignature from "../../assets/images/jadeSignature.jpg";

const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      <section id="header">
        <div className="banner">
          <img src={tcBackground} />
          <img className="logo" src={tcLogo} />
        </div>
      </section>
      <section id="link-list" className="padding-hor-24 padding-top-24">
        <p>Discover Luxury Living</p>
        <p className="description">
          With nearly two decades of experience, Thiago is your trusted guide to
          Miami’s most prestigious properties.
        </p>
        <ul>
          <li>
            <a
              href="https://youtu.be/9koZOusB25s"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={jadeSignature} />
              <p>Jade Signature #5105 | Tour</p>
            </a>
          </li>
          <li>
            <a
              href="https://jadeocean4004.miami/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={jadeOcean} />
              <p>Jade Ocean #4004</p>
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/watch?v=539QoapbfLg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ora} />
              <p>Ora By Casa Tua</p>
            </a>
          </li>
        </ul>
        <p>Contact Thiago</p>
        <p className="description">
          Ready to find your dream home? Contact Thiago Costa today to start
          your luxury real estate journey!
        </p>
        <ul>
          <li>
            <a
              href="mailto:tcosta@fir.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>Send E-mail</p>
            </a>
          </li>
          <li>
            <a
              href="https://wa.me/13053704780"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>+1 (305) 370-4780</p>
            </a>
          </li>
        </ul>
      </section>
      {/* <hr />
      <section id="contact" className="padding-hor-24">
        <h4>Contact Thiago</h4>
        <table>
          <tbody>
            <tr>
              <td className="table-key">Phone:</td>
              <td className="table-value">
                <a
                  href="https://wa.me/13053704780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +1 (305) 370-4780
                </a>
              </td>
            </tr>
            <tr>
              <td className="table-key">Email:</td>
              <td className="table-value">
                <a className="email-link" href="mailto:tcosta@fir.com">
                  tcosta@fir.com
                </a>
              </td>
            </tr>
            <tr>
              <td className="table-key">Office:</td>
              <td className="table-value">
                Fortune Christie's International
                <br />
                1390 Brickell Avenue, Suite 104
                <br />
                Miami, FL 33131
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <hr /> */}
      <footer>
        <p className="disclaimer">
          Thiago Costa Miami | copyright © 2024 | All Rights Reserved
        </p>
      </footer>
    </div>
  );
};

export default HomePage;
